import { render, staticRenderFns } from "./LayoutSidebarMenu.vue?vue&type=template&id=3849322b&scoped=true&"
import script from "./LayoutSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebarMenu.vue?vue&type=style&index=0&id=3849322b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849322b",
  null
  
)

export default component.exports